export default __webpack_public_path__ + "static/media/retake-icon.26341383.svg";